import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-GDesign";
import leftimgs from "../../../assets/threeDleftimg.png";
import rightimgs from "../../../assets/threeDrightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/threeD-benefit-img9.png";
import BenefitsDataImg2 from "../../../assets/threeD-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/threeD-benefit-img3.png";
import BenefitsDataImg4 from "../../../assets/threeD-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/threeD-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/threeD-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/threeD-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/threeD-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/threeD-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/threeDFun-img1.png";
import FunactivitiesImg2 from "../../../assets/threeDFun-img2.png";
import FunactivitiesImg3 from "../../../assets/threeDFun-img3.png";
import LearningStyle from "../../../MyComponents/LearningStyle"
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "01",
      classes: "05",
      description:"Introduction to Tinkercad- Learn the basics of Tinkercad—interface, shapes, movement, and combining objects. Ends with a simple project to apply these skills.",
    },
    {
      title: "Module 2",
      activities: "05",
      classes: "05",
      description:" Fun Projects and Simple Designs- Create practical items like keychains, toy cars, and houses. Includes a fun challenge: design a miniature garden.",
    },
    {
      title: "Module 3",
      activities: "05",
      classes: "05",
      description:"Advanced Shapes and Techniques- Explore advanced tools—holes, duplication, text, and moving parts. Final project: design your own spaceship.",
    },
    {
      title: "Module 4",
      activities: "05",
      classes: "05",
      description:" Real-World Applications and Collaboration- Work on functional designs, team projects, and prep for 3D printing. Wraps up with a final project showcase.",
    },
];    

  const benefitsData = [
      {
        title: "Learn Tinkercad Tools",
        description: "Master the interface and basic design functions.",
        icon: "Polymath-images/threeD-benefit-img9.png",
      },
      {
        title: "Improve 3D Thinking",
        description: "Boost spatial awareness and visualization skills.",
        icon: "Polymath-images/threeD-benefit-img2.png",
      },
      {
        title: "Enhance Creativity",
        description: "Design unique and functional projects.",
        icon: "Polymath-images/threeD-benefit-img3.png",
      },
      {
        title: "Gain Precision Skills",
        description: "Develop fine motor skills through detailed work.",
        icon: "Polymath-images/threeD-benefit-img4.png",
      },
      {
        title: "Understand 3D Printing.",
        description: "Learn how designs turn into physical objects.",
        icon: "Polymath-images/threeD-benefit-img5.png",
      },
      {
        title: "Make Real Projects",
        description: "Create useful items like keychains, cars, and houses.",
        icon: "Polymath-images/threeD-benefit-img6.png",
      },
      {
        title: "Collaborate with Others",
        description: "Work on group designs and team projects.",
        icon: "Polymath-images/threeD-benefit-img7.png",
      },
      {
        title: "Boost Tech Confidence",
        description: "Get comfortable using digital design tools.",
        icon: "Polymath-images/threeD-benefit-img8.png",
      },
      {
        title: "Explore STEAM Pathways",
        description: "Build skills useful in tech and engineering careers.",
        icon: "Polymath-images/threeD-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "Custom Keychain",
          image: "Polymath-images/threeDFun-img1.png",
        },
        {
          title: "Toy Car Design",
          image: "Polymath-images/threeDFun-img2.png",
        },
        {
          title: "Spaceship Model",
          image: "Polymath-images/threeDFun-img3.png",
        },
       
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const ThreeDModel = () => {
  const Modelpage = heroContent.modelsection;
  return (
    <>
     {/* <GuestNav/> */}
     <HeadSection
      leftImg={"Polymath-images/threeDleftimg.png"}
      rightImg={"Polymath-images/threeDrightimg.png"}
      titlePart1="3D Modeling with Tinkercad"
      titlePart2="Course"
      description="Discover the exciting world of 3D design! Our course teaches kids how to create digital models using Tinkercad, from basic shapes to printable designs. Perfect for beginners, this course develops spatial reasoning and creative problem-solving skills through hands-on projects."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={"Polymath-images/pencil.png"}
      button2Icon={"Polymath-images/pencil.png"}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
        title="Course Structure and Syllabus"
        modules={beginnerModules}
      />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Corel Draw"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default ThreeDModel